import React, { ReactNode } from 'react'
import cx from 'classnames'

import { CircleAvatar } from 'components/CircleAvatar'

import emptyAvatarSvg from '../../svg/emptyAvatar.svg'
import { useThemeContext } from '../../useThemeContext'

import cm from './Message.module.css'

export interface IncomingMessageProps {
  id?: string
  variant: 'incoming'
  children: ReactNode
  isPlaceholder?: boolean
  buttons?: Array<{ label: string; isPlaceholder?: boolean }>
  avatarUrl?: string
  imageUrl?: string
}

export function IncomingMessage(props: Omit<IncomingMessageProps, 'variant'>) {
  const theme = useThemeContext()

  const content = (
    <>
      <div>{props.children}</div>
      {props.buttons?.map((button, index) => (
        <div
          key={index}
          className={cx(cm.button, { [cm.buttonPlaceholder]: button.isPlaceholder })}
          data-test-id="incoming-message-button"
        >
          {button.label}
        </div>
      ))}
    </>
  )

  return (
    <div className={cm.incomingWrapper} data-test-id="incoming-message" id={props.id}>
      <div>
        {props.avatarUrl ? (
          <CircleAvatar url={props.avatarUrl} size={21} data-test-id="circle-avatar" />
        ) : (
          <img className={cm.avatar} src={emptyAvatarSvg} alt="avatar" data-test-id="avatar" />
        )}
      </div>
      <div
        className={cx(cm.message, props.imageUrl && 'p-a-0', cm.incoming, cm[theme], {
          [cm.placeholder]: props.isPlaceholder,
        })}
      >
        {props.imageUrl && <img src={props.imageUrl} className={cm.cardImage} />}
        {props.imageUrl ? <div className={cm.cardImageContent}>{content}</div> : content}
      </div>
    </div>
  )
}
